import * as React from 'react';
import Section from '../components/Section';
import { Card, Col, Image, Row, Statistic } from 'antd';

import camping from './media/camping.jpg';

export default function Camping() {

    var prices = (
        <Card title="Prisar" bordered={false} style={{ margin: "15px 5px" }}>
            <Row gutter={[16, 32]}>
                <Col xs={12} lg={8}><Statistic title="Vogn og bil inkl. 2 pers." value="320,-" /></Col>
                <Col xs={12} lg={8}><Statistic title="Bobil inkl. 2 pers." value="300,-" /></Col>
                <Col xs={12} lg={8}><Statistic title="Telt og bil inkl. 2 pers" value="280,-" /></Col>
                <Col xs={12} lg={8}><Statistic title="Telt og MC inkl. 2 pers." value="240,-" /></Col>
                <Col xs={12} lg={8}><Statistic title="Telt aleine inkl. 2 pers." value="220,-" /></Col>
                <Col xs={12} lg={8}><Statistic title="Straum" value="40,-" /></Col>
            </Row>
        </Card>
    );

    var additional = (
        <Card title="Tillegg for fleire personar" bordered={false} style={{ margin: "15px 5px" }}>
            <Row gutter={[16, 32]}>
                <Col xs={12}><Statistic title="Vaksen" value="20,-" /></Col>
                <Col xs={12}><Statistic title="Barn" value="10,-" /></Col>
            </Row>
        </Card>
    );

    return (
        <Section id="camping" title="Telt, bil og vogn">
            <Image src={camping} preview={false} style={{ marginBottom: "16px" }} width="100%" />
            <p>På campingplassen har vi plass til ca 20 bubilar, vogner og telt. Vi har delt plassen opp i 4 platå, slik at du alltid har god utsikt utover europas djupaste innsjø (514m).</p>
            <p>Tilgang på straumuttak, sanitæranlegg med dusj, wc og vaskerom/kjøkken. Det er og mogleg å leige vaskemaskin og tørketrommel.</p>
            <Row gutter={16}>
                <Col xs={24} lg={18}>{prices}</Col>
                <Col xs={24} lg={6}>{additional}</Col>
            </Row>
        </Section>
    );
}